var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        'bg-base-200',
        {
            'listener-mobile-mode': _vm.isListenerMobile,
            'listener-now-playing-mode': _vm.isListenerNowPlaying
        }
    ],attrs:{"id":"app"}},[_c('meta',{attrs:{"name":"referrer","content":"no-referrer"}}),_c('meta',{attrs:{"name":"mobile-web-app-capable","content":"yes"}}),_c('meta',{attrs:{"name":"apple-mobile-web-app-capable","content":"yes"}}),_c('meta',{attrs:{"name":"apple-mobile-web-app-status-bar-style","content":"black"}}),(_vm.$route.name !== 'login')?_c('magic-menu'):_vm._e(),(_vm.$route.name !== 'login')?_c('floating-ai-chat-launcher'):_c('div',[_c('login')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }